// extracted by mini-css-extract-plugin
module.exports = {"BasicHeader":"BasicHeader_BasicHeader__MUgsX"};